var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white -webkit-app-region: drag",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[(_vm.layout)?_c(_vm.layout,{tag:"component"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }